/** Document-scoped EORP modal (Angular `EorpDocumentPopupComponent`). */

export const DOCUMENT_EORP_MODAL_TITLE = 'Explanation of Reimbursement Process'
